import React from 'react';
import PropTypes from 'prop-types';
import {Icon, Table, Popconfirm, message, LocaleProvider, Row, Col, Card} from 'antd';
import ui from '../../lang/ui.json';
import s from './Groups.css';
import Breadcrumbs from '../../components/Breadcrumbs';
import {Link} from 'react-router-dom';
import {fetchDecode} from '../../fetchUtils';
import ContactSearch from '../contacts/ContactSearch'

class Users extends React.Component {

    static propTypes = {
        locale: PropTypes.objectOf(PropTypes.string).isRequired,
        id: PropTypes.string.isRequired,
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            data: [],
            name: '',
            config: require('Config'),
            contacts: [],
        };
    }

    componentDidMount() {
        fetchDecode(this.state.config.serverUrl + `groups/${this.props.id}`, message)
            .then(jsonUsersList => this.setState({data: jsonUsersList.members, name: jsonUsersList.name}));
    }

    successMessage = () => {
        message.success(this.props.locale.messageSuccess, 2);
    };

    errorMessage = (error) => {
        message.error(`${this.props.locale.messageError} ${error}`, 5);
    };

    deleteFromTable = (row) => {
        const dataSource = this.state.data;
        const index = dataSource.findIndex(data => data.msisdn === row);
        dataSource.splice(index, 1);
        this.setState({data: dataSource});
    };

    deleteUser = (id) => {
        fetch(this.state.config.serverUrl + `groups/deleteUser/${this.props.id}/${id}`,
            {
                headers: new Headers({
                    'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
                    'Content-Type': 'application/json',
                    'username': `${sessionStorage.getItem('username')}`
                }),
                method: 'DELETE',
            },
        ).then((response) => {
            if (response.status === 204) {
                this.successMessage();
                this.deleteFromTable(id);
            } else {
                this.errorMessage(response.statusText);
            }
        });
    };

    addUsers = (ids) => {
        fetch(this.state.config.serverUrl + `groups/${this.props.id}`,
            {
                headers: new Headers({
                    'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
                    'Content-Type': 'application/json',
                    'username': `${sessionStorage.getItem('username')}`
                }),
                method: 'PATCH',
                body: JSON.stringify({members: ids}),
            },
        )
            .then((response) => {
                if (response.status === 204) {
                    fetchDecode(this.state.config.serverUrl + `groups/${this.props.id}`, message)
                        .then(jsonUsersList => this.setState({
                            data: jsonUsersList.members,
                            name: jsonUsersList.name
                        }));
                }
                else {
                    this.errorMessage(response.statusText);
                }
            });
    }

    addingUsers = (e) => {
        e.preventDefault();
        if (this.checkValidation()) {
            this.addUsers(this.state.multiple);
        }
    };

    render() {
        const columns = [{
            title: this.props.locale.tableMSISDN,
            dataIndex: 'msisdn',
            key: 'msisdn',
            width: 250,
            sorter: (a, b) => {
                if (a.msisdn < b.msisdn) return -1;
                if (a.msisdn > b.msisdn) return 1;
                return 0;
            },
            render: text => <Link to={`/contacts/${text}`}>{text}</Link>,
        }, {
            title: this.props.locale.tableName,
            dataIndex: 'membername',
            key: 'membername',
            sorter: (a, b) => {
                if (a.membername < b.membername) return -1;
                if (a.membername > b.membername) return 1;
                return 0;
            },
        }, {
            title: '',
            key: 'delete',
            dataIndex: 'msisdn',
            width: 30,
            render: id => (
                <Popconfirm
                    title={this.props.locale.confirm}
                    onConfirm={() => this.deleteUser(id)}
                >
                    <Icon type="close-circle-o" className={s.delete}/>
                </Popconfirm>
            ),
        }];
        return (

            <LocaleProvider locale={ui}>
                <Row gutter={{ xs: 0, sm: 0, md: 0, lg: 100, xl: 100}}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                        <div className={s.root}>
                            <Breadcrumbs title={this.props.locale.breadcrumbs} link="/groups"/>
                            <div className={s.headline}>
                                <h1>{this.state.name}</h1>
                                <div className={s.headline_cont}>
                                    <Link to={`${this.props.id}/rename_group`} className={s.headline__btn}>
                                        <Icon className={s.headline__icon} type="edit"/>
                                        {this.props.locale.buttonRename}
                                    </Link>
                                </div>
                            </div>
                            <ContactSearch onSubmit={(contacts => this.addUsers(contacts))}/>
                            <Table
                                className={s.table}
                                columns={columns}
                                dataSource={this.state.data}
                                rowKey={r => r.msisdn}
                            />
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={8} style={{marginTop:120}}>
                        <Card style={{backgroundColor:"#f8f8f8"}} align="middle">
                            <p style={{fontWeight:"bold", fontSize:14}}>{this.props.locale.multiMessageGuidelinesTitle}</p>
                            <p style={{fontSize:14}}>{this.props.locale.multiMessageGuidelines1}</p>
                            <p style={{fontSize:14}}>{this.props.locale.multiMessageGuidelines2}</p>
                        </Card>
                    </Col>
                </Row>
            </LocaleProvider>
        );
    }
}

export default Users;




// WEBPACK FOOTER //
// ./src/routes/groups/Users.js